import styled from '@emotion/styled';

/**
 * Корневой элемент компонента.
 */
export const Root = styled.div``;
